import { render } from "./product.vue?vue&type=template&id=6ed0f086&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=6ed0f086&lang=css"
import "./product.vue?vue&type=style&index=1&id=6ed0f086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed0f086"]])

export default __exports__